import UAParser from 'ua-parser-js';

export const userAgentDetails = () => {
  const details = UAParser(navigator.userAgent);

  if (details.device.vendor === 'Apple' && details.device.type === undefined) {
    const hasTouchCapabilities = navigator.maxTouchPoints > 0 && 'ontouchend' in document;

    details.device.type = hasTouchCapabilities ? 'tablet' : 'desktop';
  }

  return details;
};

interface NavigatorWithClientHints {
  userAgentData?: {
    platform: string;
    getHighEntropyValues: (hints: string[]) => Promise<{ platformVersion?: string }>;
  };
}

const WINDOWS_11_MIN_PLATFORM_VERSION = 13;

export const resolveWindowsVersion = async (
  nav: Navigator = navigator
): Promise<'10' | '11' | null> => {
  const { userAgentData } = nav as Navigator & NavigatorWithClientHints;

  if (userAgentData?.platform !== 'Windows') {
    return null;
  }

  try {
    const { platformVersion } = await userAgentData.getHighEntropyValues(['platformVersion']);
    const major = parseInt(platformVersion ?? '', 10);

    if (!(major > 0)) {
      return null;
    }

    return major >= WINDOWS_11_MIN_PLATFORM_VERSION ? '11' : '10';
  } catch {
    return null;
  }
};
